import type { SessionSaccoUser } from "../types/session";
import { userRoles } from "../utilities/constanst";
import { normalizePath } from "./rbacService";

/** Firebase sign-in / sign-up only — no dashboard access. */
export const PUBLIC_AUTH_PATHS = ["/login", "/register"] as const;

/** Sacco member onboarding after Firebase auth when `saccoUser` has no profile yet. */
export const SACCO_MEMBER_ONBOARDING_PATH = "/sacco/account/register";

export function isPublicAuthPath(pathname: string): boolean {
  return (PUBLIC_AUTH_PATHS as readonly string[]).includes(
    normalizePath(pathname),
  );
}

/** True when Firestore `SaccoMembers` record is loaded on `saccoUser` (email present). */
export function hasSaccoMemberProfile(
  saccoUser: SessionSaccoUser | null | undefined,
): boolean {
  return (
    saccoUser != null &&
    typeof saccoUser.email === "string" &&
    saccoUser.email.trim().length > 0
  );
}

/** Roles with a non-root home that should also redirect away from /. */
const ROOT_REDIRECT_MAP: Partial<Record<string, string>> = {
  [userRoles.SaccoParcelUser]: "/parcel-service",
  [userRoles.StageManager]: "/sacco/stage-collections",
};

/** Default landing route after login once sacco member profile exists. */
export function resolvePostLoginPath(
  saccoUser: SessionSaccoUser | null | undefined,
): string {
  const role = String(saccoUser?.role ?? "");
  if (ROOT_REDIRECT_MAP[role]) return ROOT_REDIRECT_MAP[role]!;
  if (saccoUser?.role === userRoles.SaccoParcelAdmin) return "/";
  return "/profile";
}

/** True when the user is at / but their home is elsewhere. */
export function shouldRedirectFromRoot(
  saccoUser: SessionSaccoUser | null | undefined,
  pathname: string,
): boolean {
  if (normalizePath(pathname) !== "/") return false;
  return Boolean(ROOT_REDIRECT_MAP[String(saccoUser?.role ?? "")]);
}
